import { render, staticRenderFns } from "./AprovalPenyaluran.vue?vue&type=template&id=f2e9c8e6&scoped=true"
import script from "./AprovalPenyaluran.vue?vue&type=script&lang=js"
export * from "./AprovalPenyaluran.vue?vue&type=script&lang=js"
import style0 from "./AprovalPenyaluran.vue?vue&type=style&index=0&id=f2e9c8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9c8e6",
  null
  
)

export default component.exports